import React, { FormEvent, ReactElement } from 'react';
import {
  Button, FormGroup, Heading, LoaderButton, Radio, RadioGroup,
} from 'idsk-react-components';
import { SafeParameterSetter } from '../../../model/types/SafeParameterSetter';
import PrispevokVestnika from '../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../model/PrispevokVestnikaStepEnum';
import CheckDataTable from '../component/CheckDataTable';
import PrilohaVestnika from '../../../model/PrilohaVestnika';
import scrollToTop from '../../../function/scrollToTop';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onSubmit: (e: FormEvent<HTMLFormElement>, activeStep: PrispevokVestnikaStepEnum) => void;
  onUpdateField: SafeParameterSetter<PrispevokVestnika>;
  loading: boolean;
  clearStatus: () => void;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  isUpdate?: boolean;
  onChange: (nextStep: PrispevokVestnikaStepEnum) => Promise<void>;
}

const MainAttachmentStep5 = ({
  onSubmit,
  onUpdateField,
  prispevokVestnika,
  loading,
  clearStatus,
  getFieldErrorMessage,
  isUpdate,
  onChange,
}: Props): ReactElement => {
  const updateIsHlavnaInPrilohy = (index: number)
    : PrilohaVestnika[] => prispevokVestnika.prilohy.map((item, i) => ({
    ...item,
    hlavna: i === index,
  }));

  return (
    <div className="prispevok-vestnika-step-pages">
      <Heading className="page-title" size="xl">
        Vyberte hlavný dokument príspevku
      </Heading>
      <FormGroup error={!!getFieldErrorMessage('hlavnaPriloha')}>
        <RadioGroup error={getFieldErrorMessage('hlavnaPriloha')}>
          {prispevokVestnika.prilohy?.map((priloha, index) => (
            <Radio
              checked={priloha.hlavna || false}
              /* eslint-disable-next-line react/no-array-index-key */
              key={index}
              onChange={() => {
                onUpdateField('prilohy', updateIsHlavnaInPrilohy(index));
              }}
              title={`${priloha.nazovSuboru} (${priloha.file?.name})`}
              id={`priloha ${index}`}
              name="hlavnaPriloha"
              value={priloha.file?.name}
            />
          ))}
        </RadioGroup>
      </FormGroup>
      <LoaderButton
        loading={loading}
        type="submit"
        size="large"
        onClick={(e) => onSubmit(e, PrispevokVestnikaStepEnum.CHECK_DATA_6)}
      >Pokračovať na sumár príspevku
      </LoaderButton>
      <Button
        className="prispevok-vestnika-step-pages__back-button"
        type="button"
        buttonStyle="third"
        size="large"
        disabled={loading}
        onClick={() => {
          clearStatus();
          onUpdateField('activeStep', PrispevokVestnikaStepEnum.ATTACHMENTS_4);
          scrollToTop();
        }}
      >
        Späť
      </Button>
      <Heading size="m">Vaše odpovede</Heading>
      <CheckDataTable
        prispevokVestnika={prispevokVestnika}
        onChange={onChange}
        isUpdate={isUpdate}
      />
    </div>
  );
};

export default MainAttachmentStep5;
